import { Message, MessageBox, Notification, Loading } from 'element-ui'

let loadingInstance;
const _MessageBox=MessageBox
const _Message=Message
const _Notification=Notification
const _Loading=Loading
export default {
  // 消息提示
  msg(content) {
    _Message.info(content)
  },
  // 错误消息
  msgError(content) {
    _Message.error(content)
  },
  // 成功消息
  msgSuccess(content) {
    _Message.success(content)
  },
  // 警告消息
  msgWarning(content) {
    _Message.warning(content)
  },
  // 弹出提示
  alert(content) {
    _MessageBox.alert(content, "系统提示")
  },
  // 错误提示
  alertError(content) {
    _MessageBox.alert(content, "系统提示", { type: 'error' })
  },
  // 成功提示
  alertSuccess(content) {
    _MessageBox.alert(content, "系统提示", { type: 'success' })
  },
  // 警告提示
  alertWarning(content) {
    _MessageBox.alert(content, "系统提示", { type: 'warning' })
  },
  // 通知提示
  notify(content) {
    _Notification.info(content)
  },
  // 错误通知
  notifyError(content) {
    _Notification.error(content);
  },
  // 成功通知
  notifySuccess(content) {
    _Notification.success(content)
  },
  // 警告通知
  notifyWarning(content) {
    _Notification.warning(content)
  },
  // 确认窗体
  confirm(content) {
    return _MessageBox.confirm(content, "系统提示", {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: "warning",
    })
  },
  // 打开遮罩层
  loading(content) {
    loadingInstance = _Loading.service({
      lock: true,
      text: content,
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    })
  },
  // 关闭遮罩层
  closeLoading() {
    loadingInstance.close();
  }
}
